const icon = require('vue-svgicon');
icon.register({
    'search-thick': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M30.976 29.145l-7.614-7.918a12.888 12.888 0 003.031-8.308C26.393 5.796 20.597 0 13.471 0 6.349 0 .553 5.796.553 12.919c0 7.125 5.796 12.921 12.919 12.921 2.675 0 5.226-.805 7.403-2.34l7.675 7.982a1.66 1.66 0 001.215.518 1.685 1.685 0 001.213-2.855zM13.471 3.371c5.266 0 9.551 4.285 9.551 9.548 0 5.266-4.285 9.55-9.551 9.55-5.264 0-9.547-4.284-9.547-9.55 0-5.264 4.284-9.548 9.547-9.548z"/>`,
    },
});
